import { Select } from 'antd';
import { BaseOptionType, DefaultOptionType, SelectProps } from 'antd/es/select';
import React, { useState } from 'react';

export function isSearchFilterActive(value: unknown, inactiveValue?: unknown): boolean {
  if (Array.isArray(value)) {
    return value.length > 0;
  }
  if (value === undefined || value === null || value === '') {
    return false;
  }
  if (inactiveValue === undefined) {
    return true;
  }
  const inactiveValues = Array.isArray(inactiveValue) ? inactiveValue : [inactiveValue];
  return !inactiveValues.some((item) => item === value);
}

export function filterActiveClassName(active: boolean, className?: string) {
  return [className, active ? 'admin-filter-active' : undefined].filter(Boolean).join(' ') || undefined;
}

export type FilterSelectProps<
  ValueType = any,
  OptionType extends BaseOptionType | DefaultOptionType = DefaultOptionType,
> = SelectProps<ValueType, OptionType> & {
  /** 선택하지 않은 것과 같은 값. 비우면 값이 있을 때만 활성으로 본다. */
  inactiveValue?: unknown;
};

export function FilterSelect<
  ValueType = any,
  OptionType extends BaseOptionType | DefaultOptionType = DefaultOptionType,
>(props: FilterSelectProps<ValueType, OptionType>) {
  const { inactiveValue, className, value, defaultValue, onChange, ...rest } = props;
  const isControlled = Object.prototype.hasOwnProperty.call(props, 'value');
  const [uncontrolledValue, setUncontrolledValue] = useState(defaultValue);
  const currentValue = isControlled ? value : uncontrolledValue;

  return (
    <Select<ValueType, OptionType>
      {...rest}
      {...(isControlled ? { value } : { defaultValue })}
      className={filterActiveClassName(isSearchFilterActive(currentValue, inactiveValue), className)}
      onChange={(next, option) => {
        if (!isControlled) {
          setUncontrolledValue(next);
        }
        onChange?.(next, option);
      }}
    />
  );
}
